import React from 'react';

export function StepEmpowermentLabel() {
  return <>Zmocnění</>;
}
